import Modal from '../modal/Modal';
import { BUTTON_CONSTANTS, ON_FARM_BILLING_CONSTANTS } from '../../constants/common';
import '../lock-unlock-account-modal/lockUnlockAccountModal.scss';

type OnFarmLockModalProps = {
  isOpen: boolean;
  isBlocked: boolean;
  width?: number;
  onClose: () => void;
  onConfirm: () => void;
};

const OnFarmLockModal = ({ isOpen, isBlocked, width = 600, onClose, onConfirm }: OnFarmLockModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} width={width}>
      <div className="lock-unlock-account-modal">
        <div className="header">
          <h4>{isBlocked ? ON_FARM_BILLING_CONSTANTS.UNLOCK_ON_FARM : ON_FARM_BILLING_CONSTANTS.LOCK_ON_FARM}</h4>
        </div>
        <div className="body">
          <p>{isBlocked ? ON_FARM_BILLING_CONSTANTS.UNLOCK_CONFIRM : ON_FARM_BILLING_CONSTANTS.LOCK_CONFIRM}</p>
        </div>
        <div className="footer">
          <button className="button blue inverted small" onClick={onClose}>
            {BUTTON_CONSTANTS.CANCEL}
          </button>
          <button className="button red small" onClick={onConfirm}>
            {BUTTON_CONSTANTS.YES}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default OnFarmLockModal;
